import { StyledCheckbox } from "./CheckboxGroup.styled";
import { type SelectItem, Text } from "@mantine/core";
import type { ReactNode } from "react";

interface Props<K extends SelectItem> {
  item: K;
  renderLabel?: (item: K) => ReactNode;
  disabled?: boolean;
  wrapperStyles?: React.CSSProperties;
  labelStyles?: React.CSSProperties;
}

function CheckboxGroupItem<K extends SelectItem>({
  item,
  renderLabel,
  disabled,
  wrapperStyles,
  labelStyles,
}: Props<K>) {
  return (
    <div key={item.value} style={wrapperStyles}>
      <StyledCheckbox
        label={
          renderLabel ? (
            renderLabel(item)
          ) : (
            <Text w="100%" style={labelStyles}>
              {item.label}
            </Text>
          )
        }
        value={item.value}
        labelPosition="left"
        disabled={disabled}
      />
      {item.parts && (
        <div style={{ width: "90%", marginLeft: "auto" }}>
          {item.parts.map((part: K) => (
            <StyledCheckbox
              key={part.value}
              label={
                renderLabel ? (
                  renderLabel(part)
                ) : (
                  <Text w="100%">{part.label}</Text>
                )
              }
              value={part.value}
              labelPosition="left"
              disabled={disabled}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default CheckboxGroupItem;
